import { createRouter, createWebHistory } from "vue-router";

import HomePage from "./components/pages/Home.vue"
import AccountPage from "./components/pages/Account.vue"
import ShopsPage from "./components/pages/Shops.vue"
import StorePage from "./components/pages/Store.vue"
import StoreElement from './components/section/pages/Store/single.vue'
import StoreInformation from './components/section/pages/Store/information.vue'
import SinglePage from "./components/pages/Single.vue"
import SimcardPage from "./components/pages/Simcard.vue"
import CategoryPage from "./components/pages/Group.vue"
import AboutPage from "./components/pages/About.vue"
import ContactPage from "./components/pages/Contact.vue"
import RullsPage from "./components/pages/Rulls.vue"
import BenefitPage from "./components/pages/Benefit.vue"
import CallbackPage from "./components/pages/Callback.vue"
import TrackPage from "./components/pages/Track.vue"
import FactorPage from "./components/section/item/FactorTemp.vue"
import NotFound from "./components/pages/NotFound.vue"
import Ordinations from './components/section/pages/Group/ordination.vue'
import HomeWhole from './components/section/pages/Group/whole/home.vue'
import MainGroupWhole from './components/section/pages/Group/whole/mainGroup.vue'
import DampWhole from './components/section/pages/Group/whole/damp.vue'
import BestWhole from './components/section/pages/Group/whole/Best.vue'
const routes = [
    {
        path: "/", name: "Home", component: HomePage,
        children: [
            { path: "/invite/:id", name: "Invite", component: HomePage },
            { path: "/Poll/:id", name: "Poll", component: HomePage },
            { path: "/Map", name: "Map", component: HomePage }
        ]
    },
    { path: "/Track/:id", name: "Track", component: TrackPage },
    {
        path: "/Account", name: "Account", component: AccountPage,
        children: [
            { path: '#profile', name: 'profile', component: AccountPage },
            { path: '#score', name: 'score', component: AccountPage },
            { path: '#orders', name: 'orders', component: AccountPage },
            { path: '#benefits', name: 'benefits', component: AccountPage },
            { path: '#transactions', name: 'transactions', component: AccountPage },
            { path: '#favorites', name: 'favorites', component: AccountPage },
            { path: '#credit', name: 'credit', component: AccountPage }
        ]
    },
    { path: "/Simcard", name: "Simcard", component: SimcardPage },
    { path: "/About", name: "About", component: AboutPage },
    { path: "/Contact", name: "Contact", component: ContactPage },
    { path: "/Rules", name: "Rules", component: RullsPage },
    { path: "/Benefit", name: "Benefit", component: BenefitPage },
    {
        path: "/Store", name: "Store", component: StorePage,
        children: [
            { path: ":id", name: "StoreElement", component: StoreElement },
            { path: ":id/information", name: "StoreInformation", component: StoreInformation },
        ]
    },
    { path: "/Product/:item", name: "Single", component: SinglePage },
    { path: "/Shops/:item", name: "Shops", component: ShopsPage },
    { path: "/Category", name: "Category", component: CategoryPage,
        children: [
            { path: "Ordinations/:supplier_id/:id", name: "ordinations", component: Ordinations },
            { path: "mainGroup/:id", name: "MainWoleBtn", component: MainGroupWhole },
            { path: "Discounts/:supplier_id", name: "DampWholeBtn", component: DampWhole },
            { path: "Best/:supplier_id", name: "BestWholeBtn", component: BestWhole },
            { path: "Home/:id", name: "HomeWoleBtn", component: HomeWhole }
        ]
    },
    { path: "/Factor/:id", name: "Factor", component: FactorPage },
    {
        path: "/Callback/:type", name: "Callback", component: CallbackPage,
        children: [
            { path: ":id", name: "Callback", component: CallbackPage }
        ]
    },
    { path: "/:pathMatch(.*)*", name: "NotFound", component: NotFound },
];

const router = createRouter({
    history: createWebHistory(),
    routes
})

export default router;